export const INDEX_LOADING = "INDEX_LOADING";
export const INDEX_SUCCESS = "INDEX_SUCCESS";
export const INDEX_FAIL = "INDEX_FAIL";

export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const ORDER_DETAIL_LOADING = "ORDER_DETAIL_LOADING";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";
export const ORDER_DETAIL_CLEAR = "ORDER_DETAIL_CLEAR";
